const API_ENV = process.env.API_ENV
module.exports = {
    app_id: '210816682548850701',//dev
    app_secret: 'd22c98b028383d3d99fa68da66c30e25', //dev

    ProxyType: API_ENV,
    proxy: {
        //图片或者视频上传的api
        "common": {
            test: "https://api.dingnews.net",
            online: "https://api.dingxinwen.com"
        },
        //写稿部分的api
        "api": {
            test: "https://resource.dingnews.net",
            online: "https://resource.dingxinwen.com"
        }
    }
}
